import { EventIdType, logAmplitudeEvent } from 'amplitude/amplitude'
import { BackendLogger } from 'types/events'

export const amplitudeLogger: BackendLogger = (eventKey: EventIdType, data, eventName) => {
  const forceLimitToOne = data.forceLimitToOne || false
  const allowAnonymous = data.allowAnonymous || false
  const payload = { ...data }
  if (payload.allowAnonymous !== undefined) delete payload.allowAnonymous
  if (payload.forceLimitToOne !== undefined) delete payload.forceLimitToOne
  logAmplitudeEvent(eventKey, payload, eventName, true, forceLimitToOne, allowAnonymous)
}
